/* eslint-disable no-unused-vars */
import { useMemo } from 'react';
import { Palette } from 'config';
import styled, { css } from 'styled-components';

const formatValue = (value) => {
  if (!value) return 0;
  return Number(value).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const GenericContent = (props) => {
  const { campaignStatus } = props.data;

  const isDeletedCampaign = useMemo(() => {
    return campaignStatus === 9;
  }, [campaignStatus]);

  if (isDeletedCampaign) {
    return null;
  }

  const isEventContent = (colId) => {
    if (colId.includes('event')) {
      return true;
    }
    return false;
  };

  if (props.column.colId === 'ecpm') {
    return <Container>{props?.value ? props.value.toFixed(3).toLocaleString() : 0}</Container>;
  }
  if (props.valueType === 'dollars') return <Container>${formatValue(props?.value)}</Container>;
  if (props.valueType === 'percentage') return <Container>{formatValue(props?.value)}%</Container>;

  return (
    <Container isShowBorderLeft={isEventContent(props.column.colId)}>
      {props.value?.toLocaleString()}
    </Container>
  );
};

const Container = styled.p`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  color: ${Palette.PrimaryGray._700};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  border-left: ${({ isShowBorderLeft }) =>
    isShowBorderLeft && `1px solid ${Palette.PrimaryGray._200}`};
`;
